
<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    interests
                </mat-icon>
                <app-search-marquee #searchMarquee [searchRequestTypeEnum]="searchRequestTypeEnum"
                                    [searchRequestTileComponentTypeName]="searchRequestTileComponentTypeName"
                                    [disabled]="isSearchMarqueeDisabled">
                </app-search-marquee>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                <!--Enter search criteria to find claim types-->
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <br />
                <!--<mat-tab-group *ngIf="searchResult.length > 0">
                    <mat-tab label="Results">
                        <br />-->
                        <table mat-table [dataSource]="searchResultDatasource" class="search-result mat-elevation-z8" matSort>
                            <ng-container matColumnDef="Avatar">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let claimType" (click)="editItem(claimType.ClaimTypeId)">
                                    <mat-icon class="material-symbols-outlined">
                                        interests
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="ClaimTypeUID">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Claim Type UID</th>
                                <td mat-cell *matCellDef="let claimType" (click)="editItem(claimType.ClaimTypeId)">
                                    {{ claimType.UID }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Delete">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let claimType">
                                    <button mat-button (click)="deleteItem(claimType.ClaimTypeId, claimType.UID)">
                                        <mat-icon class="material-symbols-outlined">
                                            delete_forever
                                        </mat-icon>
                                    </button>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    <!--</mat-tab>
                </mat-tab-group>-->
            </form>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>
